<template>
  <Teleport to="body">
    <div
      class="pointer-events-none fixed bottom-0 right-0 z-[10100] flex w-full max-w-[420px] flex-col gap-2 p-4"
      data-testid="pinning-toast-region"
    >
      <TransitionGroup name="pinning-toast">
        <div
          v-for="toast in toasts"
          :key="toast.id"
          class="pointer-events-auto relative flex w-full items-start gap-3 overflow-hidden rounded-md border border-slate-700 bg-slate-800 p-4 pr-10 text-white shadow-lg"
          :class="toast.removing && 'translate-x-4 opacity-0'"
          data-testid="pinning-toast-item"
        >
          <!-- Icon -->
          <UseSvg
            v-if="toast.variant === 'error'"
            icon="alert-circle"
            class="mt-0.5 h-5 w-5 shrink-0 text-red-400"
          />
          <UseSvg
            v-else-if="toast.variant === 'success'"
            icon="check-circle"
            class="mt-0.5 h-5 w-5 shrink-0 text-green-400"
          />
          <UseSvg
            v-else-if="toast.variant === 'warning'"
            icon="alert-triangle"
            class="mt-0.5 h-5 w-5 shrink-0 text-yellow-400"
          />
          <UseSvg v-else icon="info-circle-thin" class="mt-0.5 h-5 w-5 shrink-0 text-blue-400" />

          <!-- Content -->
          <div class="flex-1">
            <div class="font-medium text-white">{{ toast.title }}</div>
            <div v-if="toast.description" class="mt-0.5 text-sm text-gray-300">
              {{ toast.description }}
            </div>
          </div>

          <!-- Close button -->
          <button
            type="button"
            class="absolute right-2 top-2 cursor-pointer rounded-full border-none bg-transparent p-1 text-white hover:bg-slate-700"
            aria-label="Close toast"
            data-testid="pinning-toast-close"
            @click="emit('dismiss', toast.id)"
          >
            <UseSvg icon="cross" class="h-4 w-4" />
          </button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup>
import UseSvg from "common/vue/components/UseSvg.vue";

defineOptions({ name: "PinningToast" });

defineProps({
  toasts: { type: Array, required: true }
});

const emit = defineEmits(["dismiss"]);
</script>

<style scoped>
.pinning-toast-enter-active {
  transition: all 0.3s ease-out;
}

.pinning-toast-leave-active {
  transition: all 0.3s ease-in;
}

.pinning-toast-enter-from {
  opacity: 0;
  transform: translateY(16px);
}

.pinning-toast-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
</style>
